import maskInput from 'vanilla-text-mask'

export default {
  params: ['maskOptions'],
  bind (el, binding, vNode) {
    const options = { ...binding.value }
    options.inputElement = el
    el.masker = maskInput(options)
  },
  unbind (el, binding, vNode) {
    el.masker.destroy()
  }
}
